import React from 'react';

import type { Control } from 'react-hook-form';

import TagContentCreate from './TagContentCreate';
import type { TagContentFormData } from './TagContentForm';
import TagContentUpdate from './TagContentUpdate';

interface Props {
  mode: 'create' | 'edit';
  tagName: string;
  control: Control<TagContentFormData>;
  onReset?: (data: TagContentFormData) => void;
  error?: string;
}

export default function TagContent({ mode, tagName, control, onReset, error }: Props) {
  if (mode === 'create') {
    return <TagContentCreate control={control} error={error} />;
  }
  return <TagContentUpdate tagName={tagName} control={control} onReset={onReset} />;
}
